module.exports = __webpack_public_path__ + "img/c178e10.jpg";